import classNames from 'classnames';
import { ThemeWBProps } from 'eco-design-micro/props/const';
import { ImgVideoProps } from 'eco-design-micro/props/img/ImgVideoProps';
import { SectionTextWithColorProps } from 'eco-design-micro/props/msg/SectionTextProps';
import EcoImgVideo from 'eco-design/base/eco-img-video';
import React from 'react';
import './index.scss';

export interface EcoSwiperLRItemProps extends ImgVideoProps, SectionTextWithColorProps {}
export interface EcoSwiperLRProps {
    /**
     * 主题色
     */
    theme?: ThemeWBProps;
    /**
     * 样式名
     */
    className?: string;
    /**
     * 列表
     */
    items: EcoSwiperLRItemProps[];
}

/**
 * 维护:谢保林
 *
 * 轮播图/视频
 */
const EcoSwiperLR: React.FC<EcoSwiperLRProps> = ({ theme = 'white', className, items = [] }) => {
    const prefixCls = `eco-swiper-l-r`;
    const classes = classNames(prefixCls, {
        [`${className}`]: className,
        [`${prefixCls}-theme-${theme}`]: theme,
        [`${prefixCls}-length-${items.length}`]: items.length,
    });

    return (
        <div className={classes}>
            <div className={`${prefixCls}-items`}>
                {items.map((item: EcoSwiperLRItemProps, index: number) => {
                    return (
                        <div className={`${prefixCls}-item ${prefixCls}-item-${index + 1}`} key={index}>
                            <div className={`${prefixCls}-item-img`}>
                                <EcoImgVideo isVideo={item.isVideo} pc={item.pc} h5={item.h5} />
                            </div>
                            <div className={`${prefixCls}-item-msg`}>
                                <div className={`${prefixCls}-item-title`}>{item.title}</div>
                                <div className={`${prefixCls}-item-subTitle`}>{item.subTitle}</div>
                                <div className={`${prefixCls}-item-desc`}>{item.desc}</div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default EcoSwiperLR;
